import React, { useEffect, useState } from "react";

function useViewportWidth() {
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 9999
  );

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return width;
}

export default function DesktopOnlyGate({ minWidth = 1024, children }) {
  const width = useViewportWidth();
  const isDesktop = width >= minWidth;

  if (!isDesktop) {
    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <div style={styles.icon}>📵</div>
          <h1 style={styles.title}>Uh-oh, not available on mobile</h1>
          <p style={styles.textSmall}>
            This app is designed for desktop screens.
          </p>
        </div>
      </div>
    );
  }

  return children;
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    padding: 24,
    background: "#0b1220",
    color: "white",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
  },
  card: {
    width: "min(520px, 100%)",
    borderRadius: 16,
    padding: 24,
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.12)",
    textAlign: "center",
  },
  icon: { fontSize: 40, marginBottom: 10 },
  title: { margin: "0 0 8px", fontSize: 22 },
  text: { margin: "0 0 8px", opacity: 0.9, lineHeight: 1.4 },
  textSmall: { margin: 0, opacity: 0.75, fontSize: 13 },
};
